import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';
import {
  PATHWAYS_INSIGHTS_URL,
  PATHWAYS_START_URL,
  TEACHERS_MEETINGS_LIST_URL,
  TEACHERS_STUDENTS_LIST,
  TEACHER_ASSIGNMENTS_V2_URL
} from 'config/urls';
import { ReactComponent as ResultsIcon } from 'images/results.svg';

import { LIVE_CLASSROOM_TEACHERS_DOMAIN } from 'utils/constants';

import { ReactComponent as AssignmentsIcon } from './assets/assignments.svg';
import { ReactComponent as BulbIcon } from './assets/light-bulb.svg';
import { ReactComponent as MeetingsIcon } from './assets/meetings.svg';
import { ReactComponent as PathwaysIcon } from './assets/pathways.svg';

const pathwaysItem = {
  key: 'pathways',
  text: 'Pathways',
  url: PATHWAYS_START_URL,
  Icon: (props) => (
    <SvgIcon {...props} component={PathwaysIcon} viewBox="2 2 20 20" />
  )
};

const getPathwaysItemsForMobile = () => [
  pathwaysItem,
  {
    key: 'insights',
    text: 'Insights',
    url: PATHWAYS_INSIGHTS_URL,
    Icon: (props) => <SvgIcon {...props} component={BulbIcon} />
  }
];

export const getLeftNavigationItems = ({ user, isMobile }) => {
  const userIsPathwaysUser = user.is_pathways_user;
  const pathwaysEnabled = userIsPathwaysUser;

  const LIVE_CLASSROOM_ENABLED =
    process.env.REACT_APP_LIVE_CLASSROOM_ENABLED === 'true';

  const isLiveTeacher =
    (user?.is_live_classroom_teacher ||
      LIVE_CLASSROOM_TEACHERS_DOMAIN.includes(user.email.split('@')[1])) &&
    LIVE_CLASSROOM_ENABLED;

  const userIsPaidUser = user.is_paid;

  // On a mobile device, when pathways is enabled we need to include only some items plus the pathways items
  if (isMobile && pathwaysEnabled) {
    return getPathwaysItemsForMobile();
  }

  if (!userIsPaidUser) {
    return [
      {
        key: 'assignments',
        text: 'Assignments',
        url: TEACHER_ASSIGNMENTS_V2_URL,
        Icon: (props) => <SvgIcon {...props} component={AssignmentsIcon} />
      },
      ...(pathwaysEnabled ? [pathwaysItem] : [])
    ];
  }

  if (isLiveTeacher) {
    return [
      {
        key: 'assignments',
        text: 'Assignments',
        url: TEACHER_ASSIGNMENTS_V2_URL,
        Icon: (props) => <SvgIcon {...props} component={AssignmentsIcon} />
      }
    ];
  }

  return [
    {
      key: 'assignments',
      text: 'Assignments',
      url: TEACHER_ASSIGNMENTS_V2_URL,
      Icon: (props) => <SvgIcon {...props} component={AssignmentsIcon} />
    },
    {
      key: 'students',
      text: 'Students',
      url: TEACHERS_STUDENTS_LIST,
      Icon: (props) => <SvgIcon {...props} component={ResultsIcon} />
    },
    {
      key: 'meetings',
      text: 'Meetings',
      Icon: (props) => <SvgIcon {...props} component={MeetingsIcon} />,
      url: TEACHERS_MEETINGS_LIST_URL
    },
    ...(pathwaysEnabled ? [pathwaysItem] : [])
  ];
};
